import { render, staticRenderFns } from "./WidgetCard.vue?vue&type=template&id=6382eabe&scoped=true"
import script from "./WidgetCard.vue?vue&type=script&lang=js"
export * from "./WidgetCard.vue?vue&type=script&lang=js"
import style0 from "./WidgetCard.vue?vue&type=style&index=0&id=6382eabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382eabe",
  null
  
)

export default component.exports